import { useTranslation } from 'react-i18next';
import type { ReferralSummary } from '@gg/shared';
import { maskEmail } from './maskEmail';

/**
 * Invitees with their state (P-08): _Registered_ in `success`, _Invited_ muted.
 * `boxed` = bordered list (screen 04b), `plain` = rows inside a card (profile 06).
 */
export function InviteeList({
  invites,
  variant,
}: {
  invites: ReferralSummary['invites'];
  variant: 'boxed' | 'plain';
}) {
  const { t } = useTranslation();
  if (invites.length === 0) return null;
  return (
    <ul
      className={`m-0 flex list-none flex-col p-0 text-sm ${
        variant === 'boxed' ? 'rounded-control border border-line px-3.5 py-1' : ''
      }`}
    >
      {invites.map((inv, i) => (
        <li
          key={inv.id}
          className={`flex justify-between gap-3 ${variant === 'boxed' ? 'py-2.5' : 'py-2'} ${
            variant === 'plain' || i > 0 ? 'border-t border-line' : ''
          }`}
        >
          <span className="truncate" title={inv.email}>
            {maskEmail(inv.email)}
          </span>
          <span
            className={
              inv.status === 'registered'
                ? 'shrink-0 font-semibold text-success'
                : 'shrink-0 text-ink-muted'
            }
          >
            {t(`referral.status.${inv.status}`)}
          </span>
        </li>
      ))}
    </ul>
  );
}
